import {useContext} from "react";
import {RiShieldKeyholeLine} from "react-icons/ri";

import Button from "@/components/button/Button.tsx";
import {Icon} from "@/components/icon/Icon.tsx";
import {VaultPageContext, VaultPageContextInterface} from "@/pages/vault/VaultPageContext.tsx";

export const VaultEmptyTableBody = () => {
  const {setShowCreateCredentialModal} = useContext<VaultPageContextInterface>(VaultPageContext);
  return (
    <div className={"d-flex flex-column align-items-center"} style={{gap: "24px"}}>
      <div>
        <RiShieldKeyholeLine size={40} />
      </div>
      <div>
        <p className={"text-center"}>
          You haven’t created any Vault Items yet. <br />
          Read our{" "}
          <a
            className={"text-body text-decoration-underline"}
            href={"https://support.uptime.com/hc/en-us/articles/15407750669852-Using-the-Uptime-com-Secure-Vault"}
            target={"_blank"}
            rel={"noreferrer"}
          >
            Support Article
          </a>{" "}
          or get started with:
        </p>
      </div>
      <div>
        <Button variant={"secondary"} onClick={() => setShowCreateCredentialModal(true)}>
          <Icon size="core" icon={RiShieldKeyholeLine} /> Create Vault Item
        </Button>
      </div>
    </div>
  );
};
